import styled from "styled-components";
export const DrawerContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background:  #f2f4fa;
  max-width: 400px;
  min-width: 350px;
  max-height: 100vh;
  border-radius: 0.5em 0 0 0.5em;
  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 100%;
  }
`;
export const DrawerHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 0.5em 0 0.5em 1em;
`;
export const DrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0.5em 1em;
  height: calc(100vh - 118px);
  overflow-y: auto;
`;
export const DrawerFooter = styled.div`
  position: absolute;
  background:  #f2f4fa;
  border-top: 1px solid #ddd;
  z-index: 1000;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.7em 1em;
  
`;
export const Button = styled.button`
  border: 1px solid #d6e0ff;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  white-space: nowrap;
  margin-bottom: 1px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.7em;
  width: 100%;
  gap: 8px;
  
`;

export const CloseButton = styled.button`
  background: transparent;
  padding: 0 0.5em;
  font-size: initial;
  margin-right: 0.5em;
  outline: none;
  border: 0px solid #ddd;
  border: 0px solid #ddd;
  cursor: pointer;
  height: 40px;
  width: 40px;
  margin-right: 0px;
  padding: 12px;
  background: ${(props) => props.theme.secBackground};
  border-radius: 50%;
  margin-top: 4px;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.bgPrimary};
  }
`;